<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <!-- Breadcrumb -->
    @if (items && items.length > 0) {
      <div class="breadcrumb-wrapper">
        <p-breadcrumb class="w-full crumb" [model]="items" [home]="home"></p-breadcrumb>
      </div>
    }

    <!-- Top Action Bar -->
    <div class="top-action-bar">
      <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
        <!-- Left: Serial Number & Status -->
        <div class="product-header-info">
          <div class="d-flex align-items-center gap-2">
            @if (galleryData.Id && galleryData.SerialNumber) {
              <div class="serial-number-box">
                <span class="serial-label">{{ 'galleryProduct.serial' | transloco }}</span>
                <span class="serial-value">{{ galleryData.SerialNumber }}</span>
              </div>
            }
            @if (galleryData.Id) {
              <span class="status-badge status-available">
                <i class="pi pi-circle-fill"></i> {{ 'galleryProduct.availableToEdit' | transloco }}
              </span>
            }
            @if (!galleryData.Id) {
              <span class="status-badge status-new">
                <i class="pi pi-plus-circle"></i> {{ 'galleryProduct.newProduct' | transloco }}
              </span>
            }
          </div>
        </div>

        <!-- Right: Action Buttons -->
        <div class="d-flex align-items-center gap-2">
          <button pButton type="button" [label]="'galleryProduct.createNew' | transloco" icon="pi pi-plus"
            class="p-button-outlined p-button-sm" (click)="createArtWork($event)">
          </button>
          @if (galleryData.Id) {
            <button type="button" pButton [label]="'galleryProduct.delete' | transloco" icon="pi pi-trash"
              class="p-button-outlined p-button-danger p-button-sm"
              (click)="deleteGalleryProduct(galleryData)">
            </button>
          }
          <button type="button" pButton icon="pi pi-save" [label]="'galleryProduct.saveProduct' | transloco"
            class="p-button-sm" (click)="saveGalleryProduct($event)"
            [disabled]="!galleryData.Name || !galleryData.ProductImgUrl">
          </button>
          @if (galleryData.Id) {
            <div class="ms-2 cursor-pointer">
              <img src="\assets\images\seemore.jpeg" [alt]="'galleryProduct.seeMore' | transloco" style="height: 40px;"
                (click)="onShowMoreProductsClicked($event)">
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Form for editing product details -->
      <form class="product-form" #productForm="ngForm">
        <div class="row">
          <div class="col-12">
            <div class="d-flex align-items-center gap-3">
              <div class="form-group flex-grow-1">
                <label class="form-label"><span class="text-danger">*</span> {{ 'galleryProduct.productName' | transloco }}</label>
                <input type="text" id="Name" name="Name" [(ngModel)]="galleryData.Name"
                  class="form-control" [placeholder]="'galleryProduct.enterProductName' | transloco" required />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-5">
                  <div class="form-group mt-2">
                    @if (!galleryData.ProductImgUrl) {
                      <div>
                        <label class="form-label">{{ 'galleryProduct.productImage' | transloco }}</label>
                        <p-fileUpload name="productImageFile" accept="image/*"
                          (onSelect)="onFileSelected($event.files, false)" [chooseLabel]="'galleryProduct.select' | transloco"
                          [auto]="true" [previewWidth]="70" styleClass="upload_image"
                          [multiple]="false" mode="advanced">
                          <ng-template pTemplate="toolbar">
                            <div class="mt-2">{{ 'galleryProduct.dragAndDropFile' | transloco }}</div>
                          </ng-template>
                        </p-fileUpload>
                      </div>
                    }
                    @if (galleryData.ProductImgUrl) {
                      <div class="position-relative d-inline-block w-100 mt-3">
                        <img [src]="galleryData.ProductImgUrl" class="img rounded w-100" />
                        <div class="position-absolute top-0 end-0 m-2">
                          <div class="cover-photo-lbl">{{ 'galleryProduct.coverPhoto' | transloco }}</div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="row mt-3">
                    <div class="col-6">
                      <div class="form-group">
                        <label for="Width" class="form-label">{{ 'galleryProduct.widthCm' | transloco }}</label>
                        <input type="number" id="Width" name="Width" class="form-control" min="0"
                          [placeholder]="'galleryProduct.width' | transloco" [(ngModel)]="galleryData.Width" (input)="preventNegativeValues($event,'Width')" />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label for="Weight" class="form-label">{{ 'galleryProduct.weightKg' | transloco }}</label>
                          <input type="number" id="Weight" name="Weight" class="form-control" min="0"
                            [placeholder]="'galleryProduct.weight' | transloco" [(ngModel)]="galleryData.Weight" (input)="preventNegativeValues($event,'Weight')" />
                          </div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-6">
                          <div class="form-group">
                            <label for="Height" class="form-label">{{ 'galleryProduct.heightCm' | transloco }}</label>
                            <input type="number" id="Height" name="Height" class="form-control" min="0"
                              [placeholder]="'galleryProduct.height' | transloco" [(ngModel)]="galleryData.Height" (input)="preventNegativeValues($event,'Height')" />
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <label for="Length" class="form-label">{{ 'galleryProduct.depthCm' | transloco }}</label>
                              <input type="number" id="Length" name="Length" class="form-control" min="0"
                                [placeholder]="'galleryProduct.length' | transloco" [(ngModel)]="galleryData.Length" (input)="preventNegativeValues($event,'Length')" />
                              </div>
                            </div>

                          </div>


                          <div class="row mt-3">
                            <div class="col-6">
                              <div class="form-group">
                                <label for="CostPrice" class="form-label">{{ 'galleryProduct.costPrice' | transloco }}</label>
                                <input type="number" id="CostPrice" name="CostPrice" class="form-control" min="0"
                                  [placeholder]="'galleryProduct.costPrice' | transloco" [(ngModel)]="galleryData.CostPrice" (input)="preventNegativeValues($event,'CostPrice')" />
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="form-group">
                                  <label for="ArtistName" class="form-label">{{ 'galleryProduct.artistName' | transloco }}</label>
                                  <input type="text" id="ArtistName" name="ArtistName" class="form-control"
                                    [placeholder]="'galleryProduct.artistName' | transloco" [(ngModel)]="galleryData.ArtistName" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-7">
                              <div class="form-group mt-2">
                                <div class="row alighn-items-center">
                                  <div class="col-6">
                                    <label for="productShortDescription" class="form-label">{{ 'galleryProduct.shortDescription' | transloco }}</label>
                                  </div>
                                  <div class="col-6 text-end">
                                    @if (galleryData.Id) {
                                      <button pButton type="button" icon="fa fa-android"
                                        [label]="'galleryProduct.generateAiDescription' | transloco"
                                        class="p-button-sm p-button-secondary p-button-outlined mb-2"
                                        [disabled]="!isProductAvailable || !galleryData.ProductImgUrl"
                                        [title]="!galleryData.ProductImgUrl? ('galleryProduct.uploadCoverImageHint' | transloco) : ('galleryProduct.aiAssistantHint' | transloco)"
                                        (click)="showChatGPTDialog($event)">
                                      </button>
                                    }
                                  </div>
                                </div>
                                <textarea id="productShortDescription" name="productShortDescription"
                                  class="form-control productShortDescription"
                                  [(ngModel)]="galleryData.ShortDescription"
                                  [placeholder]="'galleryProduct.shortDescriptionPlaceholder' | transloco" rows="3">
                                </textarea>
                              </div>
                              <div class="form-group mt-2">
                                <label for="productLongDescription" class="form-label">{{ 'galleryProduct.marketingDescription' | transloco }}</label>
                                <textarea id="productLongDescription" rows="7" name="productLongDescription"
                                  class="form-control productLongDescription"
                                  [(ngModel)]="galleryData.LongDescription"
                                [placeholder]="'galleryProduct.marketingDescriptionPlaceholder' | transloco"></textarea>
                              </div>
                              <div class="form-group mt-2">
                                <label for="productSocialMediaDescription" class="form-label">{{ 'galleryProduct.socialMediaPost' | transloco }}</label>
                                <textarea id="productSocialMediaDescription" rows="5"
                                  name="productSocialMediaDescription" class="form-control"
                                  [(ngModel)]="galleryData.SocialMediaDescription"
                                  [placeholder]="'galleryProduct.socialMediaPostPlaceholder' | transloco">
                                </textarea>
                              </div>
                              @if (galleryData.Id) {
                                <div class="form-group mt-4">
                                  <h5 class="mt-3">{{ 'galleryProduct.additionalPhotographs' | transloco }}</h5>
                                  <!-- File upload for selecting images -->
                                  <div class="justify-content-start w-100 mt-2">
                                    <p-fileUpload #additionalFileUploadCmp name="files[]" [auto]="true"
                                      [customUpload]="false" accept="image/*"
                                      (onClear)="onAdditionalFileCleard($event)"
                                      (onSelect)="onFileSelected($event.files, true)" [multiple]="false"
                                      [previewWidth]="70" cancelStyleClass="ms-2">
                                      <ng-template pTemplate="toolbar">
                                        <div class="mt-2">{{ 'galleryProduct.dragAndDropFiles' | transloco }}</div>
                                      </ng-template>
                                      <ng-template let-file pTemplate="file"></ng-template>
                                    </p-fileUpload>
                                  </div>
                                  @if (productImages && productImages.length > 0) {
                                    <!-- Display multiple selected images with remove buttons -->
                                    <div class="d-flex flex-wrap mt-3">
                                      @for (productImage of productImages; track productImage) {
                                        <div
                                          class="position-relative mt-2 me-2"
                                          (mouseenter)="handleImageHover(productImage, true)"
                                          (mouseleave)="handleImageHover(productImage, false)">
                                          <div class="image-container position-relative"
                                            [class.covered]="productImage.ImageUrl == galleryData.ProductImgUrl">
                                            <img [src]="productImage.ImageUrl" class="rounded-cube img-thumbnail"
                                              style="width: 130px; height: 130px; border:none;">
                                              <div class="hover-content position-absolute top-50 start-50 translate-middle"
                                                [class.show]="productImage.ImageUrl != galleryData.ProductImgUrl && productImage.hovered">
                                                <!-- Set cover button -->
                                                <button type="button"
                                                  class="btn btn-sm btn-primary transparent-button p-button-outlined"
                                                  [disabled]="productImage.ImageUrl == galleryData.ProductImgUrl"
                                                  (click)="updateArtistProductCoverPhoto(productImage)">
                                                  {{ 'galleryProduct.setCover' | transloco }}
                                                </button>
                                              </div>
                                              @if (productImage.ImageUrl == galleryData.ProductImgUrl) {
                                                <div class="message-bottom position-absolute start-0 bottom-0 ms-1 mb-1"
                                                  style="width: 122px;"
                                                  >
                                                  <!-- Message displayed at the bottom for the cover image -->
                                                  <div class="message-overlay">
                                                    <p class="text-center text-white ">{{ 'galleryProduct.coverPhoto' | transloco }}</p>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                            @if (productImage.ImageUrl != galleryData.ProductImgUrl) {
                                              <div class="position-absolute top-0 end-0 m-2"
                                                >
                                                <p-button type="button" size="small" [outlined]="false"
                                                  severity="danger" (click)="deleteAdditionalImage(productImage)">
                                                  <i class="fa fa-times"></i>
                                                </p-button>
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- IMAGE CROPPER COMPONENT SELECTER -->
                  @if (showCropperDialog) {
                    <app-image-cropper [showCropperDialog]="showCropperDialog" [isAdditionalImage]="isAdditionalImage"
                      [image]="currentSelectedImageToCrop" (onImageCropped)="onImageCropped($event)"
                      (onImageCropperClose)="onImageCropperClose($event)">
                    </app-image-cropper>
                  }
                  <!-- IMAGE CHATGPT-DIALOG COMPONENT SELECTER -->
                  @if (showchatGPTDialog && galleryData) {
                    <chatgpt-dialog [displayDialog]="showchatGPTDialog" [galleryProductId]="galleryData.Id"
                      [description]="galleryData.ShortDescription"
                      (onUseGeneratedSuggestion)="onUseGeneratedProductSuggestions($event)" (onClose)="closechatGPTDialog($event)">
                    </chatgpt-dialog>
                  }
                  <!-- IMAGE SHOW-MORE-PRODUCT COMPONENT SELECTER -->
                  @if (showMoreProductsSidebarVisible) {
                    <show-more-sidepanel [sidebarVisible]="showMoreProductsSidebarVisible"
                      (onClosed)="onShowMoreProductsClosed($event)">
                    </show-more-sidepanel>
                  }